import { render, staticRenderFns } from "./Placements.vue?vue&type=template&id=be738e6c&scoped=true&"
import script from "./Placements.vue?vue&type=script&lang=js&"
export * from "./Placements.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Placements.vue?vue&type=style&index=1&id=be738e6c&prod&lang=css&"
import style2 from "./Placements.vue?vue&type=style&index=2&id=be738e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be738e6c",
  null
  
)

export default component.exports